import React, { createElement, useCallback } from 'react';

import { Tag, TagSkin } from 'wix-ui-tpa/cssVars';

import { st, classes } from './ColorOption.st.css';

export const ColorOption: React.FC<{
  color: string;
  text?: string;
  onClick?: (value: string) => void;
  selected?: boolean;
  disabled?: boolean;
}> = ({ color, text, selected, disabled, onClick }) => {
  const handleClick = useCallback(() => {
    onClick?.(text ?? color);
  }, [color, onClick, text]);

  return createElement(
    Tag,
    {
      skin: TagSkin.light,
      className: st(classes.root, { selected, disabled }),
      onClick: disabled ? undefined : onClick && handleClick,
    },
    <Circle color={color} />,
    text ?? color,
  );
};

const Circle: React.FC<{ color: string }> = ({ color }) => {
  return (
    <div className={st(classes.circle)} style={{ backgroundColor: color }} />
  );
};
